import { Shift, ShiftDto, shiftFromDto } from '../../shifts/models/shift'


type ShiftsRelationDto = {
    data: ShiftDto[]
} | null

export interface EmployeeArchiveCheckDto {
    can_be_archived: boolean

    shifts: ShiftsRelationDto
}

export interface EmployeeArchiveCheck {
    canBeArchived: boolean

    shifts: Shift[]
}

export const createEmployeeArchiveCheck = (
    params: {
        canBeArchived: boolean

        shifts: Shift[]
    }
): EmployeeArchiveCheck => ({
    canBeArchived: params.canBeArchived,

    shifts: params.shifts,
})

export const employeeArchiveCheckFromDto = (dto: EmployeeArchiveCheckDto): EmployeeArchiveCheck => (createEmployeeArchiveCheck({
    canBeArchived: dto.can_be_archived,

    shifts: dto.shifts?.data.map(shiftFromDto) ?? [],
}))